<template>
    <v-chart ref="pie" :options="stage"/>
</template>

<script>
    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'
    // import 'echarts/lib/component/polar'
    // import 'echarts-gl'

    export default {
        name: "UserStagePieEcharts",
        components: {
            'v-chart': ECharts,
        },
        props:{
            pieData:Array
        },
        watch:{
          pieData: function (newVal,oldVal) {
              this.stage.series[0].data = newVal
              this.loaded()
          }
        },
        created(){
          // this.loading()
        },
        data() {
            return {
                stage: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c} ({d}%)'
                    },
                    // legend:{
                    //     orient: 'vertical',
                    //     left:'5%',
                    //     formatter: '{name}: {d}%'
                    // },
                    // labelLine: {
                    //     show: false
                    // },
                    label:{
                        formatter: '{b|{b}：}{c}  {per|{d}%}  ',
                        rich: {
                            a: {
                                color: '#999',
                                lineHeight: 20,
                                align: 'center'
                            },
                            // abg: {
                            //     backgroundColor: '#333',
                            //     width: '100%',
                            //     align: 'right',
                            //     height: 22,
                            //     borderRadius: [4, 4, 0, 0]
                            // },
                            hr: {
                                borderColor: '#aaa',
                                width: '100%',
                                borderWidth: 0.5,
                                height: 0
                            },
                            b: {
                                fontSize: 12,
                                lineHeight: 20,
                            },
                            // per: {
                            //     color: '#eee',
                            //     backgroundColor: '#334455',
                            //     padding: [2, 0],
                            //     borderRadius: 2,
                            // }
                        }
                    },
                    series: [
                        {
                            name: '阶段分布',
                            type: 'pie',
                            radius: '50%',
                            center:['50%','55%'],

                            // labelLine: {
                            //     show: false
                            // },
                            label:{
                                position: 'outer',
                                alignTo: 'labelLine',
                                // margin: 0
                            },
                            data:[
                                // {value:473, name:'小学'},
                                // {value:1, name:'中学'},
                                // {value:1, name:'大学'},
                            ]
                        }
                    ],
                    animationDuration: 1500
                },
            }
        },
        methods:{
            loading(){
                const pie = this.$refs.pie;
                pie.showLoading()
            },
            loaded(){
                const pie = this.$refs.pie;
                pie.hideLoading()
            }
        }
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 100%;
    }
</style>